// extracted by mini-css-extract-plugin
export var fadeInOut = "_1i-3";
export var icon = "_1i-4";
export var savedIndicator = "_1i-2";
export var savingIndicator = "_1i-0";
export var spin = "_1i-1";